import React from 'react'
import { StandardOpenModalButton } from 'src/components/ModalForms/ModalButtons'
import styled from 'styled-components/macro'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import {
  Tooltip,
  TooltipOverlayType,
  TooltipPositions,
} from '../../../../components/Reusable/Tooltip/Tooltip'
import { ModalFormId } from '../../../ModalForms'
import { StandardButtonSize, StandardButtonVariant } from '../StandardButton'

const ImportControlsButtonContainer = styled.div`
  display: inline-block;
`

export const ImportControlsButton = ({
  id,
  variant,
  size,
  fromEmpty,
  hasOpenAudits,
  isAdmin,
  isDisabled,
  disabledReason,
}: {
  id: string
  variant: StandardButtonVariant
  size: StandardButtonSize
  fromEmpty: boolean
  hasOpenAudits: boolean
  isAdmin: boolean
  isDisabled: boolean
  disabledReason: string
}): JSX.Element => {
  const body = isDisabled
    ? disabledReason
    : hasOpenAudits
    ? 'Not available because you have an open audit. Close all audits to import controls.'
    : ''
  const canReplaceControls = useCanPerformAction(
    CAPABILITY.CAN_REPLACE_CONTROLS,
  )
  const isButtonDisabled =
    isDisabled || hasOpenAudits || (fromEmpty && !canReplaceControls)

  return fromEmpty ? (
    <Tooltip
      id={`${id}-tooltip`}
      placement={TooltipPositions.top}
      trigger={['hover', 'focus']}
      overlayType={TooltipOverlayType.tooltip}
      tooltipBody={body}
      disabled={!body.length}
    >
      <ImportControlsButtonContainer>
        <StandardOpenModalButton
          variant={variant}
          size={size}
          modalId={ModalFormId.REPLACE_CONTROLS_CSV}
          text={
            fromEmpty
              ? 'Import Controls by Upload'
              : 'Replace Controls with Upload'
          }
          isHidden={!isAdmin}
          isDisabled={isButtonDisabled}
          disabledReason={disabledReason}
        />
      </ImportControlsButtonContainer>
    </Tooltip>
  ) : (
    <></>
  )
}
